import React from 'react';
import createReactContext from '../context';
var context = createReactContext({});
var Consumer = context.Consumer; // eslint-disable-next-line

export var Provider = context.Provider;
export var consumer = function consumer(Origin) {
  return function (props) {
    return (
      /*#__PURE__*/
      React.createElement(Consumer, null, function (_ref) {
        var bindItem = _ref.bindItem,
            unbindItem = _ref.unbindItem;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            unbindItem: unbindItem,
            bindItem: bindItem
          }))
        );
      })
    );
  };
};